import styled from 'styled-components'
import { colors } from 'client/styles'
import { CheckboxBase } from 'src/comps/Checkbox/styles'

export const CheckoutWalletSelectorBase = styled.div`
  padding-block: 16px;
  padding-inline: 16px;
  border: 2px solid ${colors.grey4};
  border-radius: 8px;
  display: flex;
  align-items: center;
  cursor: pointer;

  ${CheckboxBase} {
    flex: 1 0 auto;
    margin-block-end: 0;
    pointer-events: none;
  }

  > p {
    flex: 1 1 auto;
  }

  > span {
    margin-inline-start: 10px;
    flex: 0 0 auto;
  }
`
